<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        ref="dateInput"
        v-model="dateFormatted"
        :label="dateLabel"
        persistent-hint
        prepend-inner-icon="mdi-calendar"
        @blur="onBlur"
        @focus="onFocus"
        :error-messages="errorMessages"
        :disabled="disabled"
        @click:prepend-inner="onIconClick"
        :outlined="outlined"
        :hide-details="hideDetails"
        :dense="dense"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="onChange"
      :allowed-dates="allowedDates"
      :first-day-of-week="firstDayOfWeek"
    ></v-date-picker>
  </v-menu>
</template>

<script>
let moment = require("moment");
export default {
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    resetDate: {
      type: Boolean,
      default: false,
    },
    gtDateString: {
      type: String,
    },
    value: {
      type: String,
      default: () => "",
    },
    customLabel: {
      type: String,
    },
    rangeStart: {
      type: String,
    },
    rangeEnd: {
      type: String,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    firstDayOfWeek: {
      type: Number,
      default: () => 1,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    allowedDatesFn: {
      type: Function,
      default: null,
    },
  },

  data: () => ({
    debug: false,
    date: this.null,
    sourceDate: null,
    menu: false,
    parsedDate: {},
    datePickerFormat: "YYYY-MM-DD",
    dateFormatted: "",
  }),

  watch: {
    date(val) {
      if (val != null) {
        this.dateFormatted = this.formatDate(val);
      } else {
        this.dateFormatted = "";
      }
    },
    gtDateString(val) {
      if (val != "" && val != null) {
        this.date = moment(val).format(this.datePickerFormat);
        this.sourceDate = moment(val).format(this.datePickerFormat);
      } else {
        this.date = null;
        this.sourceDate = moment(val).format(this.datePickerFormat);
      }
    },
    value(val) {
      if (val != "" && val != null) {
        this.date = moment(val).format(this.datePickerFormat);
        this.sourceDate = moment(val).format(this.datePickerFormat);
      } else {
        this.date = null;
        this.sourceDate = moment(val).format(this.datePickerFormat);
      }
    },
  },
  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    dateLabel() {
      return this.customLabel ? this.customLabel : "Date";
    },
  },
  created() {
    if (this.gtDateString) {
      this.date = moment(this.gtDateString).format(this.datePickerFormat);
    }
    if (this.value) {
      this.date = moment(this.value).format(this.datePickerFormat);
    }
  },

  methods: {
    onIconClick(event) {
      this.menu = true;
    },
    formatDate(date) {
      if (!date) return null;
      // default gt format
      var format = "DD-MM-YYYY";
      if (this.$store.getters.userConfig) {
        format = this.$store.getters.userConfig.dateFormat;
      }
      return moment(date, this.datePickerFormat).format(format);
    },
    parseDate(date) {
      if (!date) return null;

      var format = "DD-MM-YYYY";
      if (this.$store.getters.userConfig) {
        format = this.$store.getters.userConfig.dateFormat;
      }
      return moment(date, format).format(this.datePickerFormat);
    },
    onBlur(event) {
      const newVal = event.target.value;
      const oldVal = this.date;
      const userDateFormat = this.$store.getters.userConfig.dateFormat
        ? this.$store.getters.userConfig.dateFormat
        : this.datePickerFormat;
      if (!isNaN(Number(newVal))) {
        //format to date
        const format = userDateFormat.replace(/\/|-/g, "");
        const newValStrLength = newVal.toString().length;
        if (newValStrLength >= 4) {
          const newDate = moment(newVal, format.substring(0, newValStrLength));
          //console.log(format.substring(0, newValStrLength), newDate);
          if (newDate.isValid()) {
            this.date = newDate.format(this.datePickerFormat);
            this.$emit(
              "onDateSelected",
              newDate.startOf("day").toISOString(true)
            );
            this.$emit("input", newDate.startOf("day").toISOString(true));
          } else {
            this.dateFormatted = moment(this.date).format(userDateFormat);
          }
        } else {
          this.dateFormatted = moment(this.date).format(userDateFormat);
        }
      } else {
        // try to format using user date format
        const newDate = moment(newVal, userDateFormat);
        if (newDate.isValid()) {
          this.date = newDate.format(this.datePickerFormat);
          this.$emit(
            "onDateSelected",
            newDate.startOf("day").toISOString(true)
          );
        } else {
          //console.log("setting old value: ", oldVal);
          //this.date = oldVal;
          this.dateFormatted = moment(this.date).format(userDateFormat);
        }
      }
    },
    onFocus(event) {
      if (!this.menu) {
        event.stopPropagation();
        this.menu = true;
      }
    },
    onChange(event) {
      if (this.date) {
        this.$emit(
          "onDateSelected",
          moment(this.date, this.datePickerFormat).toISOString(true)
        );
        this.$emit(
          "input",
          moment(this.date, this.datePickerFormat).toISOString(true)
        );
        //set focus on input
        this.$refs.dateInput.focus();
        this.menu = false;
      }
    },
    allowedDates(val) {
      if (this.allowedDatesFn) {
        return this.allowedDatesFn(val);
      } else {
        if (this.rangeStart != undefined && this.rangeEnd != undefined) {
          let rangeStart = moment(this.rangeStart);
          let rangeEnd = moment(this.rangeEnd);
          if (rangeStart.isValid() && rangeEnd.isValid()) {
            return moment(val).isBetween(rangeStart, rangeEnd, "days", "[]");
          }
        }
        return true;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/DatePicker.vue